<template>
  <div class="search-center">
  <Input v-model="search_value">
      <Select v-if="false" v-model="store_index" slot="prepend" style="width: 80px">
          <Option v-for="(store, index) in stores" :key="index" :value="index">{{store.name}}</Option>
      </Select>
      <Button @click="search()" slot="append" icon="ios-search"></Button>
  </Input>
  <div class="search-center-content">
    <Empty v-if="isempty"></Empty>
    <div style="max-height: 500px;overflow: scroll;" v-if="order_detail.ordersn" class="search-content">    
      <List>
          <ListItem>
            <div class="item-wrap">
            <label class="detail-label">订单号</label> 
            <span class="detail-val">{{order_detail.ordersn}}</span>
            </div>
          </ListItem>
          <ListItem>
            <div class="item-wrap">
            <label class="detail-label">日期</label> 
            <span class="detail-val">{{order_detail.created_at}}</span>
            </div>
          </ListItem>
          <ListItem>
            <div class="item-wrap">
            <label class="detail-label">客户</label> 
            <span class="detail-val">{{order_detail.buyer_username}}</span>
            </div>
          </ListItem>
          <ListItem>
            <div class="item-wrap">
            <label class="detail-label">电话号码</label> 
            <span class="detail-val">{{order_detail.recipient_phone}}</span>
            </div>
          </ListItem>
          <ListItem>
            <div class="item-wrap">
            <label class="detail-label">支付方式</label> 
            <span class="detail-val">{{order_detail.payment_method}}</span>
            </div>
          </ListItem>
          <ListItem>
            <div class="item-wrap">
            <label class="detail-label">订单金额</label> 
            <span class="detail-val">{{order_detail.order_price}}</span>
            </div>
          </ListItem>
          <ListItem>
            <div class="item-wrap">
            <label class="detail-label">实付金额</label> 
            <span class="detail-val">{{order_detail.order_paid_price}}</span>
            </div>
          </ListItem>
          
          <ListItem>
            <div class="item-wrap">
            <label class="detail-label">运费</label> 
            <span class="detail-val">{{order_detail.estimated_shipping_fee}}</span>
            </div>
          </ListItem>
          <ListItem>
            <div @click="onCopy()" style="cursor: pointer;" class="item-wrap">
              <label class="detail-label">发货地址</label> 
              <span class="detail-val">
              {{order_detail.recipient_info_app.recipient_addr}}
              </span>
            </div>
          </ListItem>
          <div>          
            <ListItem v-for="(item, index) in order_detail.products" :key="index">
                <ListItemMeta :avatar="item.item_image" :title="item.item_name" :description="getItemVal(item)" />
            </ListItem>
          </div>
          <div v-if="false" class="order-review">          
            <p>订单评价: </p>
            <div v-for="(item, index) in order_review" :key="index" class="order-review-item">
              
              <div class="" style="display: flex;align-items: center;">            
                <div class="">评分:</div>
                <div>              
                  <Rate disabled :value="item.rating" />
                </div>
              </div>
              <div v-for="(conItem, i) in item.content" :key="i" class="col-content">
                <div class="title">
                  <a>主评:</a>{{conItem.buyerCommentInfo}}</div>
                <div data-more="492800269269415" data-spm="d_allreview_sources" class="col-imgs aplus-auto-exp aplus-auto-clk" data-aplus-ae="x200_1e0b1c03" data-spm-anchor-id="a1zawg.23555074.managements_table_tr_0.d_allreview_sources.16a04edf71tkoK" data-aplus-clk="x200_1af5acd1">
                  <div v-for="(imgItem, ii) in conItem.commentImages" :key="ii" class="source-element">
                    <img :src="imgItem"></div>
                  
                </div>
                <div class="date" data-spm-anchor-id="a1zawg.23555074.managements_table_tr_0.i0.16a04edf71tkoK">{{conItem.commentTime}}</div>
                
              </div>
            </div>
          </div>
          <div class="api" slot="header"></div>
      </List>
    </div>
    <div v-if="order_detail.ordersn" style="width: 100%;text-align: center;">    
      <Button style="margin-top: 8px;" @click="openSession(order_detail.buyer_id)" :loading="loading" class="invoice-btn" type="primary" long>
        <span >打开聊天</span>
      </Button>
    </div>
  </div>
</div>
</template>
<script>
import conf from "../../conf";
import RequestUtils from "@/utils/RequestUtils";
import Empty from "../empty.vue";
// import { downloadFile } from "@/utils/ChatUtils";

export default {
  name: "faces",
  components: {
    Empty
  },
  data() {
    return {
      isempty: true,
      search_value: '',
      store_index: 0,
      order_detail: {},
      copyValue: '',
      loading: false,
      order_review: []
    };
  },
  computed: {
    stores: {
      get: function() {
        return this.$store.state.shopee.storeList;
      }
    },
    select_store: {
      get: function() {
        return this.$store.state.shopee.storeList[this.store_index];
      }
    }
  },
  methods: {
    search() {
      if (this.search_value == '') {
        this.$Message.error('请先输入关键字!');
        return false;
      }
      let self = this;
      let param = new FormData();
      param.set("order_sn", this.search_value);
      param.set("store_id", this.select_store.id);

      RequestUtils.request(conf.getOrder(), param)
      .then(function (data) {
        self.isempty = false;
        self.order_detail = data;
      })
      .then(function () {
        // self.getReviewByOrderId();
      })
    },
    getReviewByOrderId() {
      
    },
    getItemVal(item) {
      return '商品sku:'+item.sku+'  订单状态'+item.status;
    },
    getStoreVal() {
      for (let i=0; i<this.stores.length; i++) {
        if (this.stores[i].id == this.select_store.id) {
          return this.stores[i].name;
        }
      }
    },
    onCopy() {
      let skus = new Array();
      for (let i=0; i<this.order_detail.products.length; i++) {
        skus.push(this.order_detail.products[i].item_sku);
      }
      this.copyValue = this.order_detail.recipient_info_app.recipient_addr+'\n';
      this.copyValue += this.order_detail.ordersn+'\n';
      this.copyValue += this.order_detail.buyer_username+'\n';
      this.copyValue += this.order_detail.recipient_info_app.recipient_phone+'\n';
      this.copyValue += this.order_detail.created_at+'\n';
      this.copyValue += this.order_detail.store.name+'\n';
      this.copyValue += skus.join(',')+'\n';

      this.$copyText(this.copyValue).then(() => {
        this.$Message.success('已成功复制到剪切板');
      }).catch(() => {
        this.$Message.error('复制失败');
      })
    },
    openSession(buyer_id) {
      this.$store.commit("shopee/openSession", {
        buyer_id: buyer_id,
        store_id: this.order_detail.store_id
      });
    }
  },
  created: function() {
   
  }
};
</script>

<style scoped lang="scss">
.search-center {

  .search-content {
    .item-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .detail-label {
        font-weight: bold;
      }
      .detail-val {
        max-width: 300px;
      }
    }
    .invoice-btn {
      width: 100%;
      padding: 20px 0px;
      background: #fff;
      position: fiexed;
      bottom: 0px;
      text-align: center;

    }
    .order-review {
      .col-content {
        margin: 12px 5px 5px 16px;

        .title {
          margin-bottom: 4px;
          font-size: 12px;
          color: #333;
          letter-spacing: 0;
          line-height: 18px;
          overflow: hidden;
          cursor: pointer;
        }
        .col-imgs {
          .source-element {
            position: relative;
            display: inline-block;
            margin: 0 5px;
            cursor: pointer;
            img {
              width: 36px;
              height: 36px;
              background: #eee;
            }
          }
        }
        .date {
          font-family: Roboto;
          font-size: 12px;
          color: #858b9c;
          text-align: left;
          line-height: 16px;
          margin: 4px 0;
        }
      }
    }
  }
}
</style>
